import { render } from "./Index.vue?vue&type=template&id=98cba10e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=98cba10e&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=98cba10e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-98cba10e"

export default script